<script>
export default {
    props: {
        value: undefined,
        tabs: Array,
    },
    computed: {
        adjustedTabs() {
            return this.tabs.map(i => typeof i === 'object' ? i : {value: i, title: i});
        },
    },
    methods: {
        selectTab(value) {
            this.$emit('input', value);
        },
    },
};
</script>

<template>
    <div class="Tabs">
        <a
            v-for="t in adjustedTabs"
            :class="{TabItem: true, Current: t.value === value}"
            :key="t.value"
            @click="selectTab(t.value)"
            href="javascript:;"
        >
            {{ t.title }}
        </a>
        <span class="Grow"></span>
        <span>
            <slot></slot>
        </span>
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Tabs
    display flex
    //border-bottom 1px solid transparent
    padding-left 1px
    .TabItem
        outline 0
        text-decoration none
        color #afafaf
        padding 25px 35px
        //border 1px solid transparent
        //border-bottom none
        //border-radius 1px 1px 0 0
        margin-bottom -1px
        font-weight 400
        font-size 15px
        &.Current
            background #fff
            //border-color $cBorder
            color $cPrimary
            font-weight 700
    .Grow
        flex-grow 1
    &.Indent35
        padding-left 35px
</style>


